import React, { createContext, useState, useEffect, useContext, ReactNode } from "react";
import { collection, onSnapshot, query, where, QuerySnapshot } from "firebase/firestore";
import { firestore } from "../firebase";
import { InfluencerDataContext } from "./InfluencerDataContext";
import { Influencer, Collab } from "@foodfluence/shared";

export const CollabDataContext = createContext<Collab[]>([]);

export const CollabDataLoadingContext = createContext<boolean>(false);

interface CollabDataProviderProps {
    children: ReactNode;
}

export const CollabDataProvider: React.FC<CollabDataProviderProps> = ({ children }) => {
    const { influencerData } = useContext(InfluencerDataContext) as { influencerData: Influencer | null };
    const [collabData, setCollabData] = useState<Collab[]>([]);
    const [loading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        if (!influencerData?.id) {
            setCollabData([]);
            setLoading(false);
            return;
        }

        setLoading(true);
        const collabsRef = collection(firestore, "collabs");
        const q = query(collabsRef, where("influencerID", "==", influencerData.id));

        const unsubscribe = onSnapshot(q, (querySnapshot: QuerySnapshot) => {
            const collabs: Collab[] = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() } as Collab));
            setCollabData(collabs);
            setLoading(false);
        }, (error) => {
            console.error('Error loading collabs:', error);
            setLoading(false);
        });

        return () => unsubscribe();
    }, [influencerData?.id]);

    return (
        <CollabDataContext.Provider value={collabData}>
            <CollabDataLoadingContext.Provider value={loading}>
                {children}
            </CollabDataLoadingContext.Provider>
        </CollabDataContext.Provider>
    );
};